import client from './client';

export interface ProfileData {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  spouseName?: string;
  spouseEmail?: string;
  spousePhone?: string;
  address?: {
    street?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    country?: string;
  };
  emergencyContact?: {
    name?: string;
    relationship?: string;
    phone?: string;
    email?: string;
  };
  location?: string;
  churchName?: string;
}

export interface TheologicalSurveyData {
  scriptureAffirmation?: string;
  trinityUnderstanding?: string;
  humanitySinUnderstanding?: string;
  christologyExplanation?: string;
  salvationArticulation?: string;
  gospelPresentation?: string;
  ecclesiologyDefinition?: string;
  ordinancesPractice?: string;
  churchMembershipDiscipline?: string;
  officesUnderstanding?: string;
  eschatologySummary?: string;
  eschatologyMinistryShape?: string;
  believersBaptism?: string;
  churchAutonomyCooperation?: string;
  preachingPhilosophy?: string;
  discipleMakingLeadership?: string;
  worshipPhilosophy?: string;
  evangelismSocialEngagement?: string;
  theologicalDisagreement?: string;
  gospelPluralisticCulture?: string;
  contextualizationChurchPlanting?: string;
  plantingChallenges?: string;
  personalHolinessDisciplines?: string;
  marriageFamilyGuard?: string;
  conflictCriticismDiscouragement?: string;
}

export interface ReferenceData {
  name: string;
  email: string;
  phone?: string;
  relationshipType: 'pastor' | 'employer' | 'friend' | 'mentor' | 'colleague' | 'other';
  relationshipDescription?: string;
  yearsKnown?: number | '';
  organization?: string;
  position?: string;
}

export interface SendingChurchData {
  churchName: string;
  pastorName: string;
  pastorEmail: string;
  pastorPhone?: string;
  churchAddress?: {
    street?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    country?: string;
  };
  relationshipDescription?: string;
  commitmentLevel?: 'full' | 'partial' | 'none';
}

export interface OnboardingStatus {
  hasProfile: boolean;
  currentStep: string;
  onboardingCompleted: boolean;
  steps: {
    profile: boolean;
    theology: boolean;
    references: boolean;
    sendingChurch: boolean;
  };
  churchPlanter?: {
    id: number;
    name: string;
    status: string;
    stage: string;
  };
}

// Profile API calls
export const createProfile = async (profileData: ProfileData) => {
  const response = await client.post('/onboarding/profile', profileData);
  return response.data;
};

export const updateProfile = async (profileData: ProfileData) => {
  const response = await client.put('/onboarding/profile', profileData);
  return response.data;
};

export const getProfile = async () => {
  const response = await client.get('/onboarding/profile');
  return response.data;
};

// Theological Survey API calls
export const submitTheologicalSurvey = async (surveyData: TheologicalSurveyData) => {
  const response = await client.post('/onboarding/theology', surveyData);
  return response.data;
};

export const getTheologicalSurvey = async () => {
  const response = await client.get('/onboarding/theology');
  return response.data;
};

// References API calls
export const submitReferences = async (references: ReferenceData[]) => {
  const response = await client.post('/onboarding/references', { references });
  return response.data;
};

export const getReferences = async () => {
  const response = await client.get('/onboarding/references');
  return response.data;
};

// Sending Church API calls
export const submitSendingChurch = async (sendingChurchData: SendingChurchData) => {
  const response = await client.post('/onboarding/sending-church', sendingChurchData);
  return response.data;
};

export const getSendingChurch = async () => {
  const response = await client.get('/onboarding/sending-church');
  return response.data;
};

// General onboarding status
export const getOnboardingStatus = async (): Promise<OnboardingStatus> => {
  const response = await client.get('/onboarding/status');
  return response.data;
};
